import React, { useState } from "react"
import Proptypes from "prop-types"

const Para = props => {
  return (
    <div>
      <div className="para-div">
        <p className="para">{props.paratxt}</p>
      </div>
    </div>
  )
}

Para.prototype = {
  paratxt: Proptypes.any,
}
export default Para
